/**
 * The colour schemes the Admin shell can render in. The values are the CSS `color-scheme` keywords
 * verbatim, because {@link ThemeService} assigns them straight to that property (and to AG Grid's
 * `data-ag-theme-mode`, which happens to use the same two names) — keeping them identical avoids a
 * translation table whose only job would be to map each name to itself.
 */
export enum AdminTheme {
    Light = 'light',
    Dark = 'dark',
}
